import rubleIcon from '../../assets/icons/rubleIcon.svg';

function prices() {
  return ( 
    <div className='prices' id='prices'>
      <aside className='prices__aside'>
        <h2 className='prices__aside-text'>PRICE LIST</h2>
      </aside>
      <div className='prices__info'>
        <div className="prices__info-massage massage">
          <h3 className="massage__title">ПОДВОДНЫЙ МАССАЖ</h3>
          <div className="massage__items">

            <div className="massage__item">
              <div className="massage__item-header">
                <p className="massage__item-name-underlined">ПЕРВОЕ ПОСЕЩЕНИЕ</p>
                <div className="massage__item-cost">
                  <p className="massage__item-cost-number">2 000</p>
                  <img src={rubleIcon} alt="рублей" />
                </div>
              </div>
            </div>

            <div className="massage__item">
              <div className="massage__item-header">
                <p className="massage__item-name-underlined">Сеанс 45 минут</p>
                <div className="massage__item-cost">
                  <p className="massage__item-cost-number">2 500</p>
                  <img src={rubleIcon} alt="рублей" />
                </div>
              </div>
              
              <div className="massage__item-variants">
                <div className="massage__item-variant">
                  <p className="massage__item-variant-name">5 посещений</p>
                  <div className="massage__item-cost">
                    <p className="massage__item-cost-number">11 500</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>

                <div className="massage__item-variant">
                  <p className="massage__item-variant-name">10 посещений</p>
                  <div className="massage__item-cost">
                    <p className="massage__item-cost-number">20 900</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>

                <div className="massage__item-variant">
                  <p className="massage__item-variant-name">15 посещений</p>
                  <div className="massage__item-cost">
                    <p className="massage__item-cost-number">29 000</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>
              </div>
            </div>

            <div className="massage__item">
              <div className="massage__item-header">
                <p className="massage__item-name-underlined">Сеанс 60 минут</p>
                <div className="massage__item-cost">
                  <p className="massage__item-cost-number">2 900</p>
                  <img src={rubleIcon} alt="рублей" />
                </div>
              </div>
              
              <div className="massage__item-variants">
                <div className="massage__item-variant">
                  <p className="massage__item-variant-name">5 посещений</p>
                  <div className="massage__item-cost">
                    <p className="massage__item-cost-number">14 000</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>

                <div className="massage__item-variant">
                  <p className="massage__item-variant-name">10 посещений</p>
                  <div className="massage__item-cost">
                    <p className="massage__item-cost-number">26 500</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>

                <div className="massage__item-variant">
                  <p className="massage__item-variant-name">15 посещений</p>
                  <div className="massage__item-cost">
                    <p className="massage__item-cost-number">37 000</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>
              </div>
            </div>

            <div className="massage__item-header">
              <p className="massage__item-name">Соль к ванне</p>
              <div className="massage__item-cost">
                <p className="massage__item-cost-number">от 200</p>
                <img src={rubleIcon} alt="рублей" />
              </div>
            </div>

          </div>
        </div>

        <div className="prices__info-wrapping wrapping">
          <h3 className="wrapping__title">ОБЕРТЫВАНИЕ</h3>
          <div className="wrapping__items">

            <div className="wrapping__item-header">
              <p className="wrapping__item-name">STYX</p>
            </div>

            <div className="wrapping__item">
              <div className="wrapping__item-header">
                <p className="wrapping__item-name-underlined">Виски пеленания</p>
              </div>
              
              <div className="wrapping__item-variants">
                <div className="wrapping__item-variant">
                  <p className="wrapping__item-variant-name">Локально</p>
                  <div className="wrapping__item-cost">
                    <p className="wrapping__item-cost-number">4 000</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>

                <div className="wrapping__item-variant">
                  <p className="wrapping__item-variant-name">Все тело</p>
                  <div className="wrapping__item-cost">
                    <p className="wrapping__item-cost-number">5 000</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>

                <div className="wrapping__item-variant">
                  <p className="wrapping__item-variant-name">Gello-gel</p>
                  <div className="wrapping__item-cost">
                    <p className="wrapping__item-cost-number">от 500 - 3 000</p>
                    <img src={rubleIcon} alt="рублей" />
                  </div>
                </div>
              </div>
            </div>

            <div className="wrapping__item-header">
              <p className="wrapping__item-name">Массаж лица</p>
              <div className="wrapping__item-cost">
                <p className="wrapping__item-cost-number">от 2 000</p>
                <img src={rubleIcon} alt="рублей" />
              </div>
            </div>

          </div>

          <a className="prices__info-button" href="https://n1386588.yclients.com">
            <div className="prices__info-button-text" >ЗАПИСАТЬСЯ НА МАССАЖ</div>
          </a>
        </div>

      </div>
    </div>
   );
}

export default prices;